module.exports = __webpack_public_path__ + "img/mainPageIntro.be49a3c1.jpg";